import { mergeStyles, PrimaryButton } from '@fluentui/react';
import * as microsoftTeams from '@microsoft/teams-js';
import * as React from 'react';
import { logClientDebuggingEvent } from '../../../../web/utils/oneDsUtil';
import {
  AuthInfo,
  ClientTokenRetrievalInfoModel,
} from '../../../models/apiModels';
import { SourceApps, URLs } from '../../../models/constants/constants';
import { ClientAuthProvider } from '../../../utilities';
import { UnAuthSignInLinkContainer } from '../containerComponents/UnAuthSignInLinkContainer';
import { IContactUsStyles, getContactUsClassNames, getPrimaryButtonStyles } from '../styles/contactUsStyles';

import { IStyledComponent } from '../styles/themesUI';
import { getString } from '../../../../web/utils/stringLoader';

interface SignInButtonProps {
  // State Props
  sourceApp: SourceApps;
  clientTokenInfoModel: ClientTokenRetrievalInfoModel;
  isClientApp: boolean;
  namespace: string;
  redirectForSignInLink: string;
  isTeams: boolean;
  requestHistorySignin?: boolean;

  // Dispatch Functions
  dispatchSignInUser: () => void;
  dispatchRedirectForSignInLink: () => void;
  setUserIsSigningIntoClientApp: (status: boolean) => void;
  setAuthInfoForTeams: (authInfo: AuthInfo) => void;
  dispatchUserInfoFetch: () => void;
}

type ISignInButtonProps = SignInButtonProps & IStyledComponent<IContactUsStyles>;

export class SignInButton extends React.Component<ISignInButtonProps> {
  public browserSignInClickHandler = () => {
    if (this.props.sourceApp === SourceApps.SurfaceApp || this.props.sourceApp === SourceApps.SurfaceApp2) {
      window.open(
        this.props.redirectForSignInLink,
        '_self',
      );
    } else {
      window.open(
        this.props.redirectForSignInLink,
        '_blank',
        'width=500,height=700'
      );
    }
    this.props.dispatchSignInUser();
  };

  public clientAppSignInClickHandler = () => {
    this.props.setUserIsSigningIntoClientApp(true);
  };

  public signInClickHandler = () => {
    if (this.props.isTeams) {
      microsoftTeams.authentication.authenticate({
        url: window.location.origin + URLs.TeamsAuthStart,
        width: 600,
        height: 535,
        successCallback: (result) => {
          const authInfo: AuthInfo = {
            provider: ClientAuthProvider.AAD,
            token: result,
          };
          this.props.setAuthInfoForTeams(authInfo);
          this.props.dispatchUserInfoFetch();
        },
        failureCallback: (reason) => {
          console.log('Login failed: ' + reason);
        },
      });
    } else {
      this.props.isClientApp
        ? this.clientAppSignInClickHandler()
        : this.browserSignInClickHandler();
    }
  };

  public componentDidMount() {
    logClientDebuggingEvent(
      300,
      'maxfunnel',
      'SignInButton',
      'modalitiesSection',
      'SignInButton.tsx',
      'componentDidMount',
      'signInComponentInit',
      `Is client app: ${this.props.isClientApp}`
    );

    if (!this.props.isClientApp) {
      this.props.dispatchRedirectForSignInLink();
    }
  }

  public render() {
    if (!this.props.isTeams && (
      (this.props.isClientApp && this.props.clientTokenInfoModel === null) ||
      (!this.props.isClientApp && this.props.redirectForSignInLink === ''))
    ) {
      return null;
    }

    const signInMessage: string = getString('result_pleaseSignInMessage');
    const signInButtonText: string = getString('result_signInButtonText');

    const contactUsClassNames = getContactUsClassNames(this.props.styles, { theme: this.props.theme });
    const primaryButtonStyles = getPrimaryButtonStyles({ theme: this.props.theme });
    return (
      <div className={mergeStyles('col-lg-12', contactUsClassNames.col)}>
        <div className={contactUsClassNames.bodyCopySmall}>{signInMessage}</div>
        <PrimaryButton
          styles={primaryButtonStyles}
          data-bi-bhvr="SIGNIN"
          data-bi-area="modalitiesSection"
          data-bi-name="signInButton"
          data-bi-formnm="maxFunnel"
          id="signIn"
          onClick={this.signInClickHandler}
        >
          {signInButtonText}
        </PrimaryButton>
        <UnAuthSignInLinkContainer requestHistorySignin={this.props.requestHistorySignin} />
      </div>
    );
  }
}
